(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      // TWP custom class for header section
      if (this.getAttribute('data-desktop-menu-type') === 'twp-mega') {
        this.header.classList.add('section-header--custom-megamenu');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-audience-switch"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORE = 'audience:' + location.pathname;

    function sectionsOf(sw) {
      var wrapper = sw.closest('.shopify-section');
      var parent = wrapper ? wrapper.parentElement : null;
      if (!parent) return [];
      return Array.prototype.filter.call(parent.children, function (el) {
        return el.classList && el.classList.contains('shopify-section');
      });
    }

    function group(sw) {
      var current = null;
      sectionsOf(sw).forEach(function (sec) {
        var marker = sec.querySelector('[data-audience-group]');
        if (marker) {
          var k = marker.getAttribute('data-audience-group');
          current = k && k !== 'all' ? k : null;
          sec.removeAttribute('data-audience');
          return;
        }
        if (current) sec.setAttribute('data-audience', current);
        else sec.removeAttribute('data-audience');
      });
    }

    function keys(sw) {
      return Array.prototype.map.call(sw.querySelectorAll('[data-audience-tab]'), function (b) {
        return b.getAttribute('data-audience-tab');
      });
    }

    function apply(sw, key) {
      var known = keys(sw);
      if (known.indexOf(key) === -1) key = sw.getAttribute('data-default') || known[0];
      sw.setAttribute('data-active', key);
      sw.querySelectorAll('[data-audience-tab]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-audience-tab') === key ? 'true' : 'false');
      });
      sw.querySelectorAll('[data-audience-for]').forEach(function (a) {
        var f = a.getAttribute('data-audience-for');
        a.hidden = !(f === 'all' || f === key);
      });
      sectionsOf(sw).forEach(function (sec) {
        var a = sec.getAttribute('data-audience');
        if (a && a !== key) sec.setAttribute('data-audience-hidden', '');
        else sec.removeAttribute('data-audience-hidden');
      });
      return key;
    }

    function fromUrl() {
      var h = (location.hash || '').replace('#', '');
      if (h) return h;
      var m = location.search.match(/[?&]view=([^&]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }

    function start() {
      var sw = document.querySelector('[data-audience-switch]');
      if (!sw) return;
      group(sw);
      var saved = null;
      try { saved = sessionStorage.getItem(STORE); } catch (e) {}
      var wanted = fromUrl();
      if (keys(sw).indexOf(wanted) === -1) wanted = saved || sw.getAttribute('data-active') || sw.getAttribute('data-default');
      apply(sw, wanted);

      if (sw.__asBound) return;
      sw.__asBound = true;
      sw.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-audience-tab]');
        if (!btn) return;
        var key = apply(sw, btn.getAttribute('data-audience-tab'));
        try { sessionStorage.setItem(STORE, key); } catch (err) {}
        if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + '#' + key);
        var wrapper = sw.closest('.shopify-section');
        if (wrapper && wrapper.getBoundingClientRect().top <= 1) {
          window.scrollTo({ top: wrapper.offsetTop, behavior: 'auto' });
        }
      });
    }

    function editorFollow(e) {
      var sw = document.querySelector('[data-audience-switch]');
      if (!sw || !e.target) return;
      var sec = e.target.closest ? e.target.closest('.shopify-section') : null;
      var a = sec && sec.getAttribute('data-audience');
      if (a) apply(sw, a);
      if (e.type === 'shopify:block:select' && e.target.getAttribute) {
        var f = e.target.getAttribute('data-audience-for') || e.target.getAttribute('data-audience-tab');
        if (f && f !== 'all') apply(sw, f);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    window.addEventListener('hashchange', start);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(start, 0); });
    });
    document.addEventListener('shopify:section:select', editorFollow);
    document.addEventListener('shopify:block:select', editorFollow);
  })();

  } catch(e) { console.error(e); }
})();
})();
